export default {
  resmodification_requests: "طلبات التعديل",
  resreview_supplier_changes: "راجع ووافق على تغييرات المورد في الطلب",
  resorder_id: "رقم الطلب",
  ressupplier: "المورد",
  resbefore: "قبل",
  resafter: "بعد",
  resreason: "السبب",
  resstatus: "الحالة",
  resaction: "الإجراء",
  respending: "قيد الانتظار",
  resview: "عرض",
  resno_modification_requests: "لا توجد طلبات تعديل",
  resqar: "ر.ق",

  // NEW
  resmodification_request: "طلب التعديل",
  resback: "رجوع",
  respending_approval: "بانتظار الموافقة",
  resoriginal_items: "العناصر الأصلية",
  resmodified_items: "العناصر المعدلة",
  resitem: "الصنف",
  resqty: "الكمية",
  resprice: "السعر",
  resreject_changes: "رفض التعديلات",
  resaccept_changes: "قبول التعديلات"
};